import React, { Component } from 'react';

//componentes
import BalanceGeneral from './balanceG'

class Index extends Component {

    render(){
        return(
            <div>
                <BalanceGeneral />
            </div>
        );
    }

}
export default Index;